import * as ng from 'angular';
import * as moment from 'moment';

export class WeatherApiService {
   static ApiKey:string = '5fxxtnqscch6afg52vapfmz9';

   static $inject:string[] = ['$http', '$sce', '$log'];

   constructor(
      private $http:ng.IHttpService,
      private $sce:ng.ISCEService,
      private $log:ng.ILogService
   ) { }

   get(location, date) {
      date = moment(date)
      let today = moment();

      let resource = 'past-weather'
      if (date.isAfter(today)) {
         resource = 'weather';
      }

      /*
      https://www.worldweatheronline.com/developer/api/docs/local-city-town-weather-api.aspx
      https://www.worldweatheronline.com/developer/api/docs/historical-weather-api.aspx
      location: [City],[State Code] (e.g. Toronto,ON)
      location: [Lat],[Lng] (e.g. 51.253775,-85.323214)
      date: YYYY-MM-DD
      http://api.worldweatheronline.com/premium/v1/weather.ashx?q=London&format=json&num_of_days=5&key=5fxxtnqscch6afg52vapfmz9
      */
      let url = `https://api.worldweatheronline.com/premium/v1/${resource}.ashx`;
      let config = {
         cache: true,
         params: {
            key: WeatherApiService.ApiKey,
            q: location,
            format: 'json',
            num_of_days: 1,
            date: date.format('YYYY-MM-DD')
         }
      };

      return this.$http.jsonp(this.$sce.trustAsResourceUrl(url), config)
         .then((response) => this.onSuccess(response))
         .catch((e) => this.onError(e));
   }

   private onSuccess(response) {
      let data = response.data.data;

      if (!data.error && data.weather) {
         let hourly = data.weather[0].hourly;
         let index = Math.round(hourly.length / 2);

         if (index > 0) {
            return hourly[index];
         }
      }

      return this.onError(data.error);
   }

   private onError(error?) {
      this.$log.error(error);
      return { error: true };
   }
}

ng.module('e360')
   .service('weatherApi', WeatherApiService);
